module.exports = __webpack_public_path__ + "static/media/Salary_upload.18c718b8.svg";